import { render } from "./GroupRegister.vue?vue&type=template&id=239a11f0"
import script from "./GroupRegister.vue?vue&type=script&lang=js"
export * from "./GroupRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__